<template>
    <div>
        <div class="actions-tab in-tab snp-actions">
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div
                        class="info-button"
                        @click="downloadStaticFile(2)"
                    >
                        <span>
                            Режим «Мониторинг СНП»
                            <i class="icon icon-folder"></i>
                        </span>
                    </div>
                    <div class="info-title">
                        <span>Мониторинг СНП</span>
                    </div>
                    <div class="info-text">
                        <p>Данный модуль предназначен для сбора и анализа данных по формам мониторинга СНП по
                            приказу Первого заместителя Премьер-Министра Республики Казахстан - Министра
                            регионального развития Республики Казахстан от 24 сентября 2013 года № 239/ОД. .</p>
                        <div class="info-subtitle">
                            <span>Конструктор</span>
                        </div>
                        <p>Раздел предназначен для настройки рабочей области, для постоянного отслеживания и
                            сравнения интересующих, специалиста показателей, как между собой, так-же и с
                            историческими данными.</p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div @click="downloadFile">
                            <i class="icon icon-download" style="color: #01AC50; margin-left: 9px;"></i>
                            <span style="margin-right: 15px;">Скачать</span>
                        </div>
                        <i class="icon icon-keyboard"></i>
                    </div>
                </template>
                <b-dropdown-item @click="downloadFile">Констуктор</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="filter-container">
            <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                <template #button-content>
                    <span class="lc"
                    ><i class="icon icon-filter"></i> Фильтр</span
                    ><span class="rc"><i class="icon icon-keyboard"></i></span>
                </template>
                <div>
                    <div class="top-content">
                        <span>Параметры фильтра</span>
                        <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                    </div>
                    <!---------------Фильтр по шаблону-------------------->
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[0].name_ru">
                            <multiselect
                                v-model="templateVal"
                                :options="templateArr"
                                placeholder="Выберите шаблон"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="handleTemplateSelect"
                                label="name"
                            />
                            <b-button
                                v-if="templateVal && templateVal.id"
                                size="sm"
                                variant="outline-danger"
                                style="margin-top: 8px;"
                                @click="deleteTemplate"
                            >
                                Удалить шаблон
                            </b-button>
                        </b-form-group>
                    </div>
                    <!---------------Фильтр по району-------------------->
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[1].name_ru">
                            <multiselect
                                v-model="regionVal"
                                :options="regionArr"
                                placeholder="Выберите регион"
                                :allow-empty="false"
                                :show-labels="false"
                                label="nameRu"
                            />
                        </b-form-group>
                    </div>
                    <!---------------Фильтр по сельскому округу-------------------->
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[2].name_ru">
                            <multiselect
                                v-model="districtVal"
                                :options="districtArr"
                                placeholder="Выберите сельский округ"
                                :allow-empty="false"
                                :show-labels="false"
                                label="nameRu"
                            />
                        </b-form-group>
                    </div>
                    <!---------------Фильтр по СНП-------------------->
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[3].name_ru">
                            <multiselect
                                v-model="snpVal"
                                :options="snpArr"
                                placeholder="Выберите СНП"
                                :allow-empty="false"
                                :show-labels="false"
                                label="nameRu"
                            />
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-button variant="primary" @click="chgParams">Применить</b-button>
                        <b-button @click="resetFilter">Сбросить</b-button>
                    </div>
                </div>
            </b-dropdown>
            <div class="filter-actions">
                <!-- <b-button variant="primary" @click="unloadConstructor">Выгрузить</b-button> -->
                <b-button variant="light" @click="clearConstructor">Отменить</b-button>
                <b-button variant="primary" @click="saveTemplateModalVisible = true">Сохранить</b-button>
            </div>
        </div>
        <!---------Начало грид таблицы-------------->
        <b-progress
            variant="success"
            v-show="bar < 100"
            height="10px"
            :value="bar"
            striped
            animated
        ></b-progress>
        <div class="table-container">
            <div class="b-table-sticky-header table-responsive-true">
                <table
                    class="table b-table table-bordered b-table-no-border-collapse constructor-table"
                >
                    <thead>
                        <tr class="text-center">
                            <th rowspan="2" class="th-1" @click="this.toggleCollapseAll">
                                <img v-if="collapseAll" src="./icons/open.svg" alt="">
                                <img v-else src="./icons/closed.svg" alt="">
                            </th>
                            <th rowspan="2">Район</th>
                            <th rowspan="2">Сельский округ</th>
                            <th rowspan="2">СНП</th>
<!--                        <th rowspan="2">Потенциал СНП</th>-->
                            <template v-for="label of [0, 1, 2, 3, 4, 5, 6]">
                                <th :key="label" colspan="2"  v-if="currentHeads[label] === undefined" style="cursor: pointer" @click="reportTypeModal(label)">
                                    <span>Показатель</span>
                                    <i class="text-right icon icon-keyboard icon-rotate-90"></i>
                                </th>
                                <th :key="label" colspan="2" style="cursor: pointer" v-else>
                                   <span @click="reportTypeModal(label)">{{currentHeads[label].desc}}</span>
<!-- {{currentHeads[label].parentDesc}}    <i class="icon icon-close" style="float: right; cursor: pointer" @click="removeHead(label)"></i>-->
                                </th>
                            </template>
                        </tr>
                        <tr class="text-right">
                            <template v-for="yearLabel of yearLabelArr">
                                <th :key="yearLabel">
                                    <select v-model="yearHeads[yearLabel]" @change="selectYearHead(yearLabel, yearHeads[yearLabel] )">
                                        <option v-for="(year, yearIndx) in yearsArr"
                                            :key="'yearIndx' + yearIndx"
                                            :value="yearIndx">
                                            {{ year}}
                                        </option>
                                    </select>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, itemIndex) in this.globalArr">
                            <tr
                                :key="`item${itemIndex}`"
                                v-bind:class="{'table-info': item.levels === 1}"
                                v-if="item.visible"
                                :style="{
                                        backgroundColor: item.typeLevel === 1 ? '#C3E7FF' : item.typeLevel === 2 ? '#E5FBFF' : '#FFFFFF'
                                    }"
                            >
                                <td class="text-center">
                                    <button
                                        v-if="item.typeLevel === 1 || item.typeLevel === 2"
                                        type="button"
                                        class="btn btn-secondary"
                                        @click="openChildren(item)"
                                    >
                                        <img v-if="item.open" src="./icons/open.svg" alt="">
                                        <img v-else src="./icons/closed.svg" alt="">
                                    </button>

                                </td>
                                <td :style="{fontWeight: item.typeLevel === 1 ? 'bold' : null}">{{item.region}}</td>
                                <td>{{item.ruralDistrict}}</td>
                                <td>{{item.snp}}</td>
                                <td class="text-center">{{item.year1}}</td>
                                <td class="text-center">{{item.year2}}</td>
                                <td class="text-center">{{item.year3}}</td>
                                <td class="text-center">{{item.year4}}</td>
                                <td class="text-center">{{item.year5}}</td>
                                <td class="text-center">{{item.year6}}</td>
                                <td class="text-center">{{item.year7}}</td>
                                <td class="text-center">{{item.year8}}</td>
                                <td class="text-center">{{item.year9}}</td>
                                <td class="text-center">{{item.year10}}</td>
                                <td class="text-center">{{item.year11}}</td>
                                <td class="text-center">{{item.year12}}</td>
                                <td class="text-center">{{item.year13}}</td>
                                <td class="text-center">{{item.year14}}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal
            id="constructor-field"
            class="myModalProject"
            v-model="modalVisible"
            size="lg"
            centered
            content-class="modal-forms"
            hide-header
            hide-footer
            body-class="constructor-field"
        >
            <template #modal-title>
                Выберите показатель:
                <div style="padding: 7px 0px;">
                    <!-- @blur="searchHeaderText(searchHeader)" -->
                    <b-form-input  type="search" size="lg" v-model="searchHeader" placeholder="Поиск" class="mw-100">
                        <i class="icon icon-search"></i>
                    </b-form-input>
                </div>
            </template>
            <template v-for="(item, inx) of searchReportTypes">
                <div :key="inx">
                    <ul class="list-group list-group-">
                        <li
                            class="list-group-item"
                            @click="loadHeaderTypes(item.id, 0, 2021)"
                        >
                            <span v-if="item.id !== selectedType">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     class="bi bi-plus" viewBox="0 0 16 16">
                                    <path
                                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg>
                            </span>
                            <span v-else>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     class="bi bi-dash" viewBox="0 0 16 16">
                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                </svg>
                            </span>
                            {{ item.name }}
                        </li>
                    </ul>
                    <ul
                        class="list-group sub-report-type"
                        v-if="item.id === selectedType"
                    >
                        <template v-for="header of reportHeadersArr[item.id]">
                            <template v-if="header.visible === true">
                                <template v-if="item.name === 'Демография' && header.description.trim() === 'Численность населения'">
                                    <li
                                        :key="header.id"
                                        class="list-group-item"
                                        @click="handleHeaderClick(header)"
                                    >
                                        <span>{{`${"&emsp;".repeat(header.depth)} ${header.description}`}}</span>

                                    </li>
                                </template>
                                <template v-else-if="!checkInVisible(header.description.trim(), item.id)">
                                    <li
                                        :key="header.id"
                                        class="list-group-item"
                                        v-if="!checkOnClick(header.description, item.id)"
                                        @click="handleHeaderClick(header)"
                                    >
                                        <span>{{`${"&emsp;".repeat(header.depth)} ${header.description}`}}</span>

                                    </li>
                                    <li
                                        :key="header.id"
                                        class="list-group-item not-cursor"
                                        v-else-if="checkOnClick(header.description, item.id)"
                                        title="Невозможно выбрать"
                                    >
                                        <span>{{`${"&emsp;".repeat(header.depth)} ${header.description}`}}</span>
                                    </li>
                                </template>
                            </template>

                        </template>
                    </ul>
                </div>
            </template>
        </b-modal>
        <b-modal
            id="save-template-form"
            v-model="saveTemplateModalVisible"
            size="sm"
            centered
            title="Введите название шаблона"
            hide-footer
            hide-header
        >
            <b-form class="save-template-form">
                <b-form-group
                    label="Введите название шаблона"
                    label-for="template-name-input"
                >
                    <b-form-input size="sm" id="theme" v-model="templateName" ></b-form-input>
                </b-form-group>
                <b-button-group>
                    <b-button variant="success" @click="saveTemplate">Сохранить</b-button>
                    <b-button variant="light" @click="saveTemplateModalVisible = false">Отменить</b-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { MonitoringSnpApi } from '@/modules/monitoring-snp/api/MonitoringSnpApi';
import { isEmpty } from 'lodash';
import { notClickContructorNew, notViewNew } from './consts/notClick'
import { Ax } from "@/utils";

// Базовый URL нового API «Конструктора отчётов»
const CONSTRUCTOR_URL = '/snp/api/v1/constructor';

export default {
    name: 'constructor',
    props: ['me', 'regionArr', 'yearsArr'],
    data() {
        return {
            bar: 100,
            collapseAll: true,
            globalArr: [],
            sgpDoc: [
                {
                    'name_ru': 'Шаблон',
                    'name_kk': 'Шаблон',
                    'name_en': 'Template'
                },
                {
                    'name_ru': 'Район',
                    'name_kk': 'Райой',
                    'name_en': 'District'
                },
                {
                    'name_ru': 'Сельский округ',
                    'name_kk': 'Сельский округ',
                    'name_en': 'Rural district'
                },
                {
                    'name_ru': 'СНП',
                    'name_kk': 'СНП',
                    'name_en': 'SNP'
                },
                {
                    'name_ru': 'Период',
                    'name_kk': 'Период',
                    'name_en': 'Period'
                }
            ],
            yearLabelArr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            regionVal: null,
            districtVal: null,
            districtArr: [],
            snpVal: null,
            snpArr: [],
            templateVal: null,
            templateArr: [],
            modalVisible: false,
            saveTemplateModalVisible: false,
            subReportTypes: null,
            reportHeadersArr: {},
            selectedType: null,
            selectedHeaderIndx: null,
            childCounts: [],
            currentHeads: [],
            yearHeads: [],
            templateName: null,
            searchHeader: '',
            searchReportTypes: [],
            reportTypes: [],
            // КАТО-код, по которому построена текущая таблица (корень дерева конструктора)
            lastCatoCode: null
        };
    },
    mounted() {
        this.loadTypes();
        this.loadTemplates();
    },
    watch: {
        regionVal: function() {
            this.districtVal = null;
            this.snpVal = null;
            if (this.regionVal?.nameRu === 'Все') {
                this.districtArr = [];
                this.snpArr = [];
            }
            this.regionVal?.code && this.loadDistricts();
        },
        districtVal: function () {
            this.snpVal = null;
            if (this.districtVal?.nameRu === 'Все') {
                this.snpArr = []
            }
            this.districtVal?.code && this.loadSnp();
        },
        searchHeader: function() {
            this.searchHeaderText(this.searchHeader);
        }
    },
    methods: {
        downloadFile() {
            if (isEmpty(this.templateVal)) {
                 this.makeToast('danger', 'Вы не сохранили шаблон или не выбрали шаблон из списка', 'Ошибка');
                return;
            }

            const templateId = this.templateVal.id;
            const url = `/snp/api/v1/report/file/template?templateId=${templateId}`;
            Ax(
                {
                    url,
                    method: 'GET',
                    data: null,
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    }
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.templateVal.name}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log('err', error);
                }
            );

        },
        loadTypes() {
            MonitoringSnpApi
                .get('/snp/api/v1/report/types')
                .then(res => {
                    this.reportTypes = res.data;
                    this.searchReportTypes = res.data;
                })
                .catch(() => {
                });
        },
        handleTemplateSelect() {
            this.regionVal = this.districtVal = this.snpVal = null;
        },
        checkOnClick(desc, itemId) {
            const item = notClickContructorNew[itemId - 1][itemId];
            return item.includes(desc.trim().toLowerCase());
        },
        checkInVisible(desc, itemId) {
            const item = notViewNew[itemId - 1][itemId];
            return item.includes(desc.trim().toLowerCase());
        },
        removeHead(columnIdx) {
            this.$set(this.currentHeads, columnIdx, undefined);
        },
        reportTypeModal(columnIdx) {
            this.selectedHeaderIndx = columnIdx;
            this.modalVisible = true;
        },
        // "F014" -> 14 (числовой id типа отчёта)
        toReportTypeId(formCode) {
            return parseInt(String(formCode).replace(/\D/g, ''), 10);
        },
        // 14 -> "F014" (код формы для constructor-API)
        toFormCode(reportTypeId) {
            return `F${String(reportTypeId).padStart(3, '0')}`;
        },
        loadTemplates() {
            MonitoringSnpApi.get(`${CONSTRUCTOR_URL}/templates`)
                .then(res => {
                    this.templateArr = res.data?.data || [];
                })
                .catch(err => console.log(err));
        },
        deleteTemplate() {
            if (isEmpty(this.templateVal)) {
                return;
            }
            MonitoringSnpApi.delete(`${CONSTRUCTOR_URL}/template/${this.templateVal.id}`)
                .then(() => {
                    this.makeToast('info', 'Шаблон удалён', 'Успешно');
                    this.templateVal = null;
                    this.loadTemplates();
                })
                .catch(err => {
                    const message = err?.response?.data?.message || 'Не удалось удалить шаблон';
                    this.makeToast('danger', message, 'Ошибка');
                });
        },
        // Выполняет сохранённый шаблон: восстанавливает показатели/годы
        // и загружает деревья значений одним запросом
        runTemplate() {
            const template = this.templateVal;
            this.lastCatoCode = String(template.catoCode);
            this.globalArr = [];
            this.currentHeads = [];
            this.yearHeads = [];
            (template.items || []).slice(0, 7).forEach((item, idx) => {
                this.$set(this.currentHeads, idx, {
                    idx,
                    desc: `${item.formCode} / показатель №${item.indicatorCode}`,
                    type: this.toReportTypeId(item.formCode),
                    columnNumber: item.indicatorCode,
                    formCode: item.formCode,
                    indicatorCode: item.indicatorCode
                });
                this.resolveHeadDesc(idx);
                (item.years || []).slice(0, 2).forEach((year, yearIdx) => {
                    const yearIndex = this.yearsArr.findIndex((y) => y === year);
                    if (yearIndex !== -1) {
                        this.$set(this.yearHeads, idx * 2 + yearIdx, yearIndex);
                    }
                });
            });
            this.bar = 40;
            MonitoringSnpApi.get(`${CONSTRUCTOR_URL}/template/${template.id}/tree`)
                .then(res => this.applyBatchResponse(res.data?.data))
                .catch(err => {
                    const message = err?.response?.data?.message || 'Не удалось выполнить шаблон';
                    this.makeToast('danger', message, 'Ошибка');
                })
                .finally(() => (this.bar = 100));
        },
        // В шаблоне названия показателя нет — восстанавливаем его из справочника заголовков формы
        resolveHeadDesc(sectionIdx) {
            const head = this.currentHeads[sectionIdx];
            if (!head?.type) {
                return;
            }
            MonitoringSnpApi
                .get(`/snp/api/v1/report/headers/type?type=${head.type}&year=2021`)
                .then(res => {
                    const header = (res.data || []).find((h) => +h.columnNumber === +head.indicatorCode);
                    if (header) {
                        this.$set(this.currentHeads, sectionIdx, {
                            ...head,
                            desc: header.description,
                            id: header.id,
                            parentId: header.parentId
                        });
                    }
                })
                .catch(() => {});
        },
        // Собирает элементы batch-запроса из выбранных показателей и годов
        buildBatchItems() {
            const items = [];
            this.currentHeads.forEach((head, idx) => {
                if (!head) {
                    return;
                }
                const years = [...new Set(
                    [this.yearsArr[this.yearHeads[idx * 2]], this.yearsArr[this.yearHeads[idx * 2 + 1]]]
                        .filter((year) => year !== undefined)
                )];
                if (years.length) {
                    items.push({ formCode: head.formCode, indicatorCode: head.indicatorCode, years });
                }
            });
            return items;
        },
        refreshAllColumns(items = this.buildBatchItems()) {
            if (!this.lastCatoCode || !items.length) {
                return;
            }
            this.bar = 40;
            MonitoringSnpApi.post(`${CONSTRUCTOR_URL}/batch/${this.lastCatoCode}`, items)
                .then(res => this.applyBatchResponse(res.data?.data))
                .catch(() => this.makeToast('danger', 'По указанным параметрам не существует данных!', 'Ошибка'))
                .finally(() => (this.bar = 100));
        },
        // Раскладывает ответ batch-запроса (или шаблона) по колонкам таблицы
        applyBatchResponse(results) {
            (results || []).forEach((result) => {
                const sectionIdx = this.currentHeads.findIndex(
                    (h) => h && h.formCode === result.formCode && +h.indicatorCode === +result.indicatorCode
                );
                if (sectionIdx === -1) {
                    return;
                }
                (result.years || []).forEach((yearTree) => {
                    const colIdx = this.findColumnForYear(sectionIdx, yearTree.year);
                    if (colIdx !== -1) {
                        this.applyTreeValues(yearTree.tree, colIdx);
                    }
                });
            });
        },
        findColumnForYear(sectionIdx, year) {
            const first = sectionIdx * 2;
            if (this.yearsArr[this.yearHeads[first]] === year) {
                return first;
            }
            if (this.yearsArr[this.yearHeads[first + 1]] === year) {
                return first + 1;
            }
            return -1;
        },
        makeRow({ code, typeLevel, parentCode, visible, region, ruralDistrict, snp, potentialSnp }) {
            const row = {
                id: String(code),
                code: String(code),
                parent: false,
                levels: 1,
                typeLevel: +typeLevel,
                visible: !!visible,
                parent_id: parentCode ? String(parentCode) : 0,
                open: false,
                region: region || '',
                ruralDistrict: ruralDistrict || '',
                snp: snp || '',
                potentialSnp: potentialSnp || ''
            };
            for (let i = 1; i <= 14; i++) {
                row[`year${i}`] = '';
            }
            return row;
        },
        // Строит строки таблицы из дерева КАТО, которое возвращает constructor-API
        buildSkeletonFromTree(root) {
            const rows = [];
            const walk = (node, names, parentCode, visible) => {
                if (+node.type === 0) {
                    (node.children || []).forEach((child) => walk(child, {}, null, true));
                    return;
                }
                const nodeNames = {
                    region: +node.type === 1 ? node.nameRu : names.region,
                    ruralDistrict: +node.type === 2 ? node.nameRu : names.ruralDistrict,
                    snp: +node.type === 3 ? node.nameRu : ''
                };
                rows.push(this.makeRow({
                    code: node.catoCode,
                    typeLevel: node.type,
                    parentCode,
                    visible,
                    ...nodeNames
                }));
                (node.children || []).forEach((child) => walk(child, nodeNames, node.catoCode, false));
            };
            walk(root, {}, null, true);
            this.globalArr = rows;
        },
        // Показывает иерархию КАТО сразу после применения фильтра, пока не выбран ни один показатель
        loadKatoSkeleton(code) {
            MonitoringSnpApi.get(`/snp/api/v1/admin/all-child?code=${code}`)
                .then(res => {
                    if (this.globalArr.length) {
                        return;
                    }
                    this.globalArr = this.buildRowsFromKatoList(res.data || []);
                })
                .catch(err => console.log('err', err));
        },
        buildRowsFromKatoList(list) {
            const rows = [];
            const ids = new Set(list.map((item) => item.id));
            const walk = (item, names, parentCode, visible) => {
                if (+item.type === 0) {
                    list.filter((child) => child.parentId === item.id)
                        .forEach((child) => walk(child, {}, null, true));
                    return;
                }
                const nodeNames = {
                    region: +item.type === 1 ? item.nameRu : names.region,
                    ruralDistrict: +item.type === 2 ? item.nameRu : names.ruralDistrict,
                    snp: +item.type === 3 ? item.nameRu : ''
                };
                rows.push(this.makeRow({
                    code: item.code,
                    typeLevel: item.type,
                    parentCode,
                    visible,
                    potentialSnp: item.codePotenSnp,
                    ...nodeNames
                }));
                list.filter((child) => child.parentId === item.id)
                    .forEach((child) => walk(child, nodeNames, item.code, false));
            };
            list.filter((item) => !ids.has(item.parentId))
                .forEach((item) => walk(item, {}, null, true));
            return rows;
        },
        // Проставляет значения одного дерева (форма+показатель+год) в колонку colIdx
        applyTreeValues(tree, colIdx) {
            if (!tree) {
                return;
            }
            if (!this.globalArr.length) {
                this.buildSkeletonFromTree(tree);
            }
            const field = `year${colIdx + 1}`;
            const rowsByCode = {};
            this.globalArr.forEach((row) => {
                rowsByCode[row.code] = row;
                row[field] = '';
            });
            const walk = (node) => {
                const row = rowsByCode[String(node.catoCode)];
                if (row) {
                    row[field] = node.value === null || node.value === undefined ? '' : node.value;
                }
                (node.children || []).forEach(walk);
            };
            walk(tree);
        },
        loadSectionColumns(sectionIdx) {
            this.fetchColumn(sectionIdx, sectionIdx * 2);
            this.fetchColumn(sectionIdx, sectionIdx * 2 + 1);
        },
        // Одиночный запрос дерева для одной колонки (показатель + год)
        fetchColumn(sectionIdx, colIdx) {
            const head = this.currentHeads[sectionIdx];
            const year = this.yearsArr[this.yearHeads[colIdx]];
            if (!head || year === undefined) {
                return;
            }
            const code = this.lastCatoCode || (this.getCodeValue() ? String(this.getCodeValue()) : null);
            if (!code) {
                this.makeToast('danger', 'Сначала выберите район в фильтре', 'Ошибка');
                return;
            }
            this.lastCatoCode = code;
            this.bar = 40;
            MonitoringSnpApi.get(`${CONSTRUCTOR_URL}/${head.formCode}/${code}`, {
                indicatorCode: head.indicatorCode,
                year
            })
                .then(res => this.applyTreeValues(res.data?.data?.tree, colIdx))
                .catch(() => this.makeToast('danger', `Нет данных по показателю за ${year} год`, 'Ошибка'))
                .finally(() => (this.bar = 100));
        },
        loadHeadersArr(typeId, parent = {}) {
            const parentId = parent?.id || 0;
            this.subReportTypes.forEach((report) => {
                if (report.parentId === parentId && report.visible === true) {
                    this.childCounts[parentId] = this.childCounts[parentId]
                        ? this.childCounts[parentId] + 1
                        : 1;
                    this.reportHeadersArr[typeId].push({
                        ...report,
                        open: true,
                        visible: true,
                        childCount: 0
                    });
                    this.loadHeadersArr(typeId, report);
                }
            });
        },
        loadDistricts() {
            try {
                MonitoringSnpApi
                    .get(`/snp/api/v1/admin/dict-kato?parentId=${this.regionVal.id}`)
                    .then(res => {
                        this.districtArr = [{nameRu: 'Все'}, ...res.data];
                    })
                    .catch(err => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        loadSnp() {
            try {
                MonitoringSnpApi
                    .get(`/snp/api/v1/admin/dict-kato?parentId=${this.districtVal.id}`)
                    .then(res => {
                        this.snpArr = [{nameRu: 'Все'}, ...res.data];
                    })
                    .catch(err => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        resetFilter() {
            this.regionVal = null;
            this.districtVal = null;
            this.snpVal = null;
            this.templateVal = null;
            this.lastCatoCode = null;
            this.clearConstructor();
            this.hideFiltersPanel();
        },
        hideFiltersPanel() {
            this.$refs.drop.hide(true);
        },
        loadHeaderTypes(typeId, parentId, selectedYear) {
            if (typeId === this.selectedType) {
                this.selectedType = null;
            } else {
                if (!this.reportHeadersArr.hasOwnProperty(typeId)) {
                    try {
                        MonitoringSnpApi
                            .get(`/snp/api/v1/report/headers/type?type=${typeId}&year=${selectedYear}`)
                            .then(res => {
                                this.subReportTypes = res.data;
                                this.reportHeadersArr[typeId] = [];
                                this.loadHeadersArr(typeId);
                                this.selectedType = typeId;
                            })
                            .catch(err => console.log(err));
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    this.selectedType = typeId;
                }
            }
        },
        getCodeValue() {
            if (this.snpVal?.code) {
                return this.snpVal.code;
            }
            if (this.districtVal?.code) {
                return this.districtVal.code;
            }
            return this.regionVal?.code;
        },
        chgParams() {
            if (this.templateVal) {
                this.runTemplate();
                this.hideFiltersPanel();
                return;
            }
            if (!this.regionVal?.code) {
                this.makeToast('danger', 'Вы не выбрали район', 'Ошибка');
                return;
            }
            this.lastCatoCode = String(this.getCodeValue());
            this.globalArr = [];
            const items = this.buildBatchItems();
            if (items.length) {
                this.refreshAllColumns(items);
            } else {
                this.loadKatoSkeleton(this.lastCatoCode);
            }
            this.hideFiltersPanel();
        },
        toggleCollapseAll() {
            this.collapseAll = !this.collapseAll;
            this.globalArr.forEach(item => {
                if (item.typeLevel !== 1) {
                    if (this.collapseAll) {
                        item.visible = true;
                        item.open = true;
                    } else {
                        item.visible = false;
                        item.open = false;
                    }
                }
            });
        },
        openChildren(parent, bool) {
            parent.open = bool === undefined ? !parent.open : bool;
            for (const row of this.globalArr) {
                if (parent.id === row.parent_id) {
                    if ([1, 2].includes(row.typeLevel)) {
                        this.openChildren(row, parent.open);
                    }
                    row.visible = parent.open;
                }
            }
        },
        handleHeaderClick(header) {
            let head = {};
            let str = '';
            head = this.reportHeadersArr[header.type].filter((x) => x.id === header.parentId);
            if (head.length > 0) {
                if (head[0].parentId !== null) {
                    str = head[0].description + str;
                    head = this.reportHeadersArr[header.type].filter((x) => x.id === head[0].parentId);
                    if (head.length > 0) {
                        if (head[0].parentId !== null) {
                            str = head[0].description + '/' + str;
                        }
                    }
                }
            }
            const selectedHead = {
                idx: this.selectedHeaderIndx,
                id: header.id,
                desc: str === '' ? header.description : str + '/' + header.description,
                type: header.type,
                columnNumber: header.columnNumber,
                parentId: header.parentId,
                formCode: this.toFormCode(header.type),
                indicatorCode: header.columnNumber
            };
            this.$set(this.currentHeads, this.selectedHeaderIndx, selectedHead);
            this.modalVisible = false;
            // для новых секций подставляем годы, выбранные в первой секции
            if (this.selectedHeaderIndx !== 0) {
                if (this.yearHeads[0] !== undefined) {
                    this.$set(this.yearHeads, this.selectedHeaderIndx * 2, this.yearHeads[0]);
                }
                if (this.yearHeads[1] !== undefined) {
                    this.$set(this.yearHeads, this.selectedHeaderIndx * 2 + 1, this.yearHeads[1]);
                }
            }
            this.loadSectionColumns(this.selectedHeaderIndx);
        },
        clearConstructor() {
          this.currentHeads = [];
          this.yearHeads = [];
          this.globalArr = [];
        },
        saveTemplate() {
            if (!this.templateName || this.templateName.trim() === '') {
                this.makeToast('danger', 'Вы не ввели наименование шаблона', 'Ошибка');
                return false;
            }
            const catoCode = this.lastCatoCode
                || (this.getCodeValue() ? String(this.getCodeValue()) : null);
            if (!catoCode) {
                this.makeToast('danger', 'Не выбран район в фильтре', 'Ошибка');
                return false;
            }
            const items = this.buildBatchItems();
            if (!items.length) {
                this.makeToast('danger', 'Не выбран ни один показатель с годом', 'Ошибка');
                return false;
            }
            const body = {
                name: this.templateName.trim(),
                catoCode,
                items
            };

            MonitoringSnpApi
                .post(`${CONSTRUCTOR_URL}/template`, body)
                .then(res => {
                    if (res.status === 200) {
                        this.makeToast('info', 'Шаблон успешно сохранен', 'Успешно');
                        this.saveTemplateModalVisible = false;
                        this.templateName = null;
                        this.loadTemplates();
                    }
                })
                .catch(err => {
                    const message = err?.response?.data?.message || 'Не удалось сохранить шаблон';
                    this.makeToast('danger', message, 'Ошибка');
                });
        },
        getHeaderByYearIndex(yearIndex){
            let selectedHeaderIndx = 0;
            switch (yearIndex) {
                case 0:
                case 1:
                    selectedHeaderIndx = 0;
                    break;
                case 2:
                case 3:
                    selectedHeaderIndx = 1;
                    break;
                case 4:
                case 5:
                    selectedHeaderIndx = 2;
                    break;
                case 6:
                case 7:
                    selectedHeaderIndx = 3;
                    break;
                case 8:
                case 9:
                    selectedHeaderIndx = 4;
                    break;
                case 10:
                case 11:
                    selectedHeaderIndx = 5;
                    break;
                case 12:
                case 13:
                    selectedHeaderIndx = 6;
                    break;
                default:
                    break;
            };
            return selectedHeaderIndx;
        },
        selectYearHead(indx, selectedValue) {
            const sectionIdx = this.getHeaderByYearIndex(indx);
            if (this.currentHeads[sectionIdx] === undefined) {
                this.makeToast('danger', 'Вы не выбрали Показатель!', 'Ошибка');
                this.$set(this.yearHeads, indx, undefined);
                return;
            }
            this.$set(this.yearHeads, indx, selectedValue);
            this.fetchColumn(sectionIdx, indx);
        },
        searchHeaderText(searchText) {
            if (!isEmpty(searchText)) {
                const arrFilter = this.searchReportTypes;
                const item = arrFilter.filter(item => item.description.toLowerCase().includes(searchText.toLowerCase()));
                this.searchReportTypes = item;
            } else {
                this.searchReportTypes = this.reportTypes;
            }
        },
        makeToast(variant = null, tostbody, title) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                autoHideDelay: 4000,
                solid: true
            });
        },
        downloadStaticFile(id) {
            const url = `/snp/api/v1/report/file/infoTemplate/${id}`;
            const name = +id === 1 ? "СВОД 2022-I полугодие.xlsx" : "Режим Мониторинг СНП.pdf";
            Ax(
                {
                    url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                    (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", name);
                    document.body.appendChild(link);
                    link.click();
                    },
                    (error) => {
                    console.log("err", error);
                }
            );
        },
    }
};
</script>
<style scoped>
img {
    cursor: pointer;
}
.constructor-table > tbody > tr:first-child > td {
    font-weight: bold;
}

.save-template-form > label {
    font-size: 14px;
    font-weight: 600;
}

li {
    cursor: pointer;
}

li:hover {
    background-color: #f6f6f6;
}

.not-cursor {
    cursor: help
}

</style>
